import React from "react";
import PropTypes from "prop-types";
import { openSkopicApp } from "src/Utils/deviceDetection";
import "./MobileAppBanner.css";

const logoPath = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/skopic-logo.png` : "/skopic-logo.png";

const MobileAppBanner = ({ onClose, communityName, emailActionData }) => {
  const handleOpenClick = () => {
    try {
      openSkopicApp({ communityName, emailActionData });
    } catch (err) {
      console.error("Error opening app or store URL:", err);
    }
  };

  return (
    <div className="mobile-app-banner" id="skopic-smart-app-banner">
      <div className="banner-left">
        {onClose && (
          <button
            type="button"
            className="banner-close-btn"
            onClick={onClose}
            aria-label="Close app banner"
          >
            &times;
          </button>
        )}
        <img
          src={logoPath}
          alt="Skopic App Icon"
          className="banner-app-icon"
        />
        <div className="banner-text-info">
          <div className="banner-app-title">Skopic</div>
          <div className="banner-app-subtitle">Open in the Skopic app</div>
        </div>
      </div>
      <div className="banner-right">
        <button
          type="button"
          className="banner-open-btn"
          onClick={handleOpenClick}
          id="banner-open-app-btn"
        >
          OPEN
        </button>
      </div>
    </div>
  );
};

MobileAppBanner.propTypes = {
  onClose: PropTypes.func,
  communityName: PropTypes.string,
  emailActionData: PropTypes.object,
};

export default MobileAppBanner;
